import {setAbstractRuntimeString} from '@shopify/shopify-api/runtime';

import {setAppBridgeUrlOverride} from '../../authenticate/helpers';

setAbstractRuntimeString(() => {
  return `React Router (Node)`;
});

/* eslint-disable no-process-env */
if (process.env.APP_BRIDGE_URL) {
  setAppBridgeUrlOverride(process.env.APP_BRIDGE_URL);
}
/* eslint-enable no-process-env */
